module.exports = __webpack_public_path__ + "static/img/poster_bg1.f0276739.png";